/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p.illustrated[_ngcontent-%COMP%]{clear:both;overflow:hidden;margin-bottom:2rem}p.illustrated[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{float:left;width:100%;max-width:400px;margin-bottom:1rem;margin-right:1rem;border-radius:.25rem}p.illustrated[_ngcontent-%COMP%]   img.right[_ngcontent-%COMP%]{float:right;margin-right:0;margin-left:1rem}@media (max-width:991.98px){p.illustrated[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:50%}}@media (max-width:767.98px){p.illustrated[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:none;margin:0 0 1rem 0}}"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/puppet/puppet.component.scss.shim.ngstyle.js.pre-build-optimizer.js